import { SpecializedMethodologyRegistryItem } from '../types/predictionDifferentiation';
import { LifeArea } from './integratedProfileGenerator';

export const SPECIALIZED_METHODOLOGY_REGISTRY: SpecializedMethodologyRegistryItem[] = [
  {
    id: 'METH_D1_RASHI',
    name: 'D1 Rashi & Bhava Lagna Kundali',
    category: 'PARASHARI',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['career', 'wealth', 'marriage', 'progeny', 'health', 'property', 'education', 'foreignTravel', 'spirituality'],
    relevantChartTypes: ['D1'],
    evidenceFields: ['Lagna Sign', 'Lagna Lord', 'Bhavas 1-12', 'Occupants', 'Aspects', 'Dignities'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'Brihat Parashara Hora Shastra, Ch. 11-24'
  },
  {
    id: 'METH_D2_HORA',
    name: 'D2 Hora Chart (Wealth & Liquid Assets)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['wealth', 'career', 'property'],
    relevantChartTypes: ['D2'],
    evidenceFields: ['Sun Hora Count (Solar/Active Assets)', 'Moon Hora Count (Lunar/Liquid Accumulation)', 'Dominant Hora Balance', '2nd/11th Lord in Hora'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'Brihat Parashara Hora Shastra, Ch. 6 (Hora Varga)'
  },
  {
    id: 'METH_D3_DREKKANA',
    name: 'D3 Drekkana (Courage, Siblings & 22nd Drekkana Health Diagnostic)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['health', 'career', 'foreignTravel'],
    relevantChartTypes: ['D3'],
    evidenceFields: ['3rd House Siblings', 'Mars/Mercury Dignity', '22nd Drekkana (Kharesh)', 'Decanate Rulers'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'Saravali & BPHS Ch. 6'
  },
  {
    id: 'METH_D4_CHATURTHAMSHA',
    name: 'D4 Chaturthamsha (Fixed Assets, Real Estate & Net Fortune)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['property', 'wealth'],
    relevantChartTypes: ['D4'],
    evidenceFields: ['4th House Real Estate', 'Mars & Saturn Placements', 'Fixed Property Fortunes'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_D7_SAPTAMSHA',
    name: 'D7 Saptamsha (Progeny, Lineage & Children Prosperity)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['progeny', 'education'],
    relevantChartTypes: ['D7'],
    evidenceFields: ['5th/9th House in D7', 'Jupiter Placement in D7', 'Child-bearing indicators'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6 & Jaimini Sutras'
  },
  {
    id: 'METH_D9_NAVAMSHA',
    name: 'D9 Navamsha (Dharma, Marriage & Innate Destiny)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['marriage', 'career', 'spirituality', 'wealth'],
    relevantChartTypes: ['D9'],
    evidenceFields: ['Vargottama Planets', '7th House & 7th Lord in D9', 'Venus & Jupiter in D9', '64th Navamsha (Khara Navamsha)'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6 & Phaladeepika Ch. 3'
  },
  {
    id: 'METH_D10_DASAMSHA',
    name: 'D10 Dasamsha (Great Accomplishments, Career Rank & Status)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['career', 'wealth'],
    relevantChartTypes: ['D10'],
    evidenceFields: ['10th House in D10', '10th Lord in D10', 'Sun/Saturn/Mercury Status in D10', 'Digbala in D10'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6 & Jataka Parijata'
  },
  {
    id: 'METH_D12_DWADASAMSHA',
    name: 'D12 Dwadasamsha (Parents & Ancestral Karma)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['health', 'spirituality'],
    relevantChartTypes: ['D12'],
    evidenceFields: ['9th/4th Houses in D12', 'Sun (Father) & Moon (Mother) Dignity in D12'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_D16_SHODASHAMSHA',
    name: 'D16 Shodashamsha (Conveyances, Vehicles & Luxuries)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['property', 'wealth'],
    relevantChartTypes: ['D16'],
    evidenceFields: ['4th House in D16', 'Venus in D16', 'Vehicle Comfort & Travel Safety'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_D20_VIMSAMSHA',
    name: 'D20 Vimsamsha (Spiritual Awakening, Upasana & Sadhana)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['spirituality'],
    relevantChartTypes: ['D20'],
    evidenceFields: ['5th/9th/12th House in D20', 'Jupiter & Ketu in D20', 'Mantra Siddhi Indicators'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_D24_CHATURVIMSAMSHA',
    name: 'D24 Chaturvimsamsha (Higher Learning, Academic Excellence & Vidya)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['education', 'career'],
    relevantChartTypes: ['D24'],
    evidenceFields: ['4th/5th/9th House in D24', 'Mercury & Jupiter in D24', 'Competitive Exam Strength'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_D27_SAPTAVIMSAMSHA',
    name: 'D27 Saptavimsamsha (Nakshatramsha: Inner Vitality & Mental Resilience)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['health', 'career', 'spirituality'],
    relevantChartTypes: ['D27'],
    evidenceFields: ['Strength of 3rd/6th in D27', 'Physical & Psychological Endurance'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_D30_TRIMSAMSHA',
    name: 'D30 Trimsamsha (Arishta, Inherent Flaws & Misfortunes)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['health', 'marriage', 'spirituality'],
    relevantChartTypes: ['D30'],
    evidenceFields: ['6th/8th/12th Lords in D30', 'Planetary Impurities & Protective Grahas'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6 & Jataka Parijata'
  },
  {
    id: 'METH_D40_KHAVEDAMSHA',
    name: 'D40 Khavedamsha (Auspicious Vibrations & Maternal Lineage Blessings)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['spirituality', 'wealth'],
    relevantChartTypes: ['D40'],
    evidenceFields: ['Subtle Benefic Impulses', 'Maternal Family Blessings'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'INTERNAL_METRIC',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_D45_AKSHAVEDAMSHA',
    name: 'D45 Akshavedamsha (General Well-being & Paternal Lineage)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['spirituality', 'health'],
    relevantChartTypes: ['D45'],
    evidenceFields: ['Character Balance', 'Paternal Karmic Inheritance'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'INTERNAL_METRIC',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_D60_SHASHTIAMSHA',
    name: 'D60 Shashtiamsha (Past Life Karma, Destiny Root & Prarabdha)',
    category: 'DIVISIONAL_VARGA',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['career', 'wealth', 'marriage', 'progeny', 'health', 'property', 'education', 'foreignTravel', 'spirituality'],
    relevantChartTypes: ['D60'],
    evidenceFields: ['Deity / Shashtiamsha Nature (Benefic vs Malefic)', 'Prarabdha Root Confirmation'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 6'
  },
  {
    id: 'METH_INDU_LAGNA',
    name: 'Indu Lagna (Moon Wealth Ascendant Calculation)',
    category: 'SPECIAL_LAGNAS',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['wealth', 'career'],
    relevantChartTypes: ['D1', 'D2'],
    evidenceFields: ['Indu Lagna Sign', 'Indu Lagna Lord', 'Planets in Indu Lagna', 'Aspects on Indu Lagna'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'Jataka Parijata & Uttara Kalamrita'
  },
  {
    id: 'METH_22ND_DREKKANA',
    name: '22nd Drekkana (Kharesh - 8th House Decanate Ruler)',
    category: 'DIAGNOSTIC_POINTS',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['health'],
    relevantChartTypes: ['D1', 'D3'],
    evidenceFields: ['22nd Drekkana Lord', 'Planets transiting 22nd Drekkana', 'Health vulnerability zones'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'Brihat Jataka & Phaladeepika'
  },
  {
    id: 'METH_64TH_NAVAMSHA',
    name: '64th Navamsha (Khara Navamsha - 8th House Navamsha Ruler)',
    category: 'DIAGNOSTIC_POINTS',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['health', 'marriage', 'spirituality'],
    relevantChartTypes: ['D1', 'D9'],
    evidenceFields: ['64th Navamsha Lord', 'Transit of Malefics across 64th Navamsha'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'Prashna Marga & Jataka Parijata'
  },
  {
    id: 'METH_MARAKA_MARAKESH',
    name: 'Maraka & Marakesh (2nd & 7th House Rulers Diagnostic)',
    category: 'DIAGNOSTIC_POINTS',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['health'],
    relevantChartTypes: ['D1'],
    evidenceFields: ['2nd Lord (Maraka)', '7th Lord (Maraka)', 'Planets in 2nd/7th', 'Dasha timing of Maraka planets'],
    synthesisEligibility: true,
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 44'
  },
  {
    id: 'METH_CLASSICAL_YOGAS',
    name: 'Classical Parashari Yogas (Raja, Dhana, Mahapurusha & Gajakesari)',
    category: 'PARASHARI',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['career', 'wealth', 'spirituality', 'education'],
    relevantChartTypes: ['D1', 'D9'],
    evidenceFields: ['Pancha Mahapurusha Yogas', 'Dhana Yogas (1-2-5-9-11 combinations)', 'Raja Yogas (Kendra-Trikona)', 'Gajakesari Yoga'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 34-42 & Phaladeepika'
  },
  {
    id: 'METH_DOSHAS_AFFLICTIONS',
    name: 'Classical Astrological Doshas (Mangal, Kaal Sarp, Guru Chandal, Shani-Rahu Pitra)',
    category: 'PARASHARI',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['marriage', 'career', 'health', 'progeny'],
    relevantChartTypes: ['D1'],
    evidenceFields: ['Mangal Dosha & House Position', 'Kaal Sarp Yoga Type', 'Guru Chandal Conjunction', 'Pitra Dosha Indicators'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'Muhurta Chintamani & Classical Shastras'
  },
  {
    id: 'METH_VIMSHOTTARI_DASHA',
    name: 'Vimshottari Dasha System (Mahadasha, Antardasha & Pratyantardasha)',
    category: 'TIMING_AND_TRANSITS',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['career', 'wealth', 'marriage', 'progeny', 'health', 'property', 'education', 'foreignTravel', 'spirituality'],
    relevantChartTypes: ['D1', 'D9', 'D10'],
    evidenceFields: ['Active Mahadasha Planet', 'Active Antardasha Planet', 'Lordship & Dignity of Dasha Lords', 'Dasha Sandhi Periods'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 46-52'
  },
  {
    id: 'METH_GOCHAR_SADE_SATI',
    name: 'Real-Time Planetary Gochar, Sade Sati & Dhaiyya',
    category: 'TIMING_AND_TRANSITS',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['career', 'wealth', 'marriage', 'health', 'property'],
    relevantChartTypes: ['D1', 'Transit'],
    evidenceFields: ['Saturn Transit from Natal Moon', 'Sade Sati Phase (Rising/Peak/Setting)', 'Kantaka / Ashtama Shani (Dhaiyya)', 'Jupiter Transit Houses', 'Rahu-Ketu Transit Axis'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'Phaladeepika Ch. 26 & Mansagari'
  },
  {
    id: 'METH_DOUBLE_TRANSIT',
    name: 'Double Transit Principle (Jupiter & Saturn Combined Aspect on Houses)',
    category: 'TIMING_AND_TRANSITS',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['career', 'marriage', 'progeny', 'property'],
    relevantChartTypes: ['D1', 'Transit'],
    evidenceFields: ['Houses simultaneously aspected/occupied by transit Jupiter & transit Saturn', 'Manifestation Activation Window'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'K.N. Rao Research & Classical Transit Shastras'
  },
  {
    id: 'METH_ASHTAKAVARGA_SAV_BAV',
    name: 'Ashtakavarga System (Samudaya Ashtakavarga & Bhinna Ashtakavarga)',
    category: 'PARASHARI',
    calculationStatus: 'FROZEN_ACTIVE',
    validationStatus: 'MATHEMATICALLY_VERIFIED',
    relevantLifeAreas: ['wealth', 'career', 'property', 'health'],
    relevantChartTypes: ['D1'],
    evidenceFields: ['SAV points per house (1-12)', '11th House SAV vs 12th House SAV (Income vs Expenditure)', 'BAV Bindus of transiting planets', 'Kakshya divisions'],
    synthesisEligibility: true,
    userExposureLevel: 'PUBLISHED_SYNTHESIS',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'BPHS Ch. 66-72'
  },
  {
    id: 'METH_KP_PADHDHATI',
    name: 'KP System (Krishnamurti Padhdhati - Star Lord & Sub Lord Precision)',
    category: 'KP_PADHDHATI',
    calculationStatus: 'STANDALONE_ISOLATED',
    validationStatus: 'CLASSICALLY_ALIGNED',
    relevantLifeAreas: ['career', 'marriage', 'property', 'foreignTravel'],
    relevantChartTypes: ['KP_Cusp_Chart'],
    evidenceFields: ['Cuspal Sub Lords 1-12', 'Star Lord Significations', 'Ruling Planets', 'KP Significators (A, B, C, D)'],
    synthesisEligibility: false, // Strict architectural boundary: KP logic remains isolated from Parashari synthesis
    userExposureLevel: 'ASTROLOGER_CORE_ONLY',
    technicalVisibilityLevel: 'EXPLAINABLE_EVIDENCE',
    classicalReference: 'K.S. Krishnamurti Readers 1-6'
  }
];

export function getRegisteredMethodology(id: string): SpecializedMethodologyRegistryItem | undefined {
  return SPECIALIZED_METHODOLOGY_REGISTRY.find(m => m.id === id);
}

export function getMethodologiesForLifeArea(area: LifeArea): SpecializedMethodologyRegistryItem[] {
  return SPECIALIZED_METHODOLOGY_REGISTRY.filter(m => m.relevantLifeAreas.includes(area));
}

export function getAllMethodologies(): SpecializedMethodologyRegistryItem[] {
  return SPECIALIZED_METHODOLOGY_REGISTRY;
}
